{
  "eyebrow": "Ci sei",
  "title": "Benvenuto su Done-it, {{company}}.",
  "sub": "La tua prova di 30 giorni di {{plan}} è attiva. Tre prossimi passi.",
  "next1": {
    "title": "Scarica l'app mobile",
    "desc": "Invia al tuo team il link di installazione via SMS o email.",
    "cta": "Invia link di invito"
  },
  "next2": {
    "title": "Invita il tuo team",
    "desc": "Importa i dipendenti in blocco da CSV o aggiungili uno alla volta.",
    "cta": "Apri amministrazione"
  },
  "next3": {
    "title": "Guarda un tour di 4 minuti",
    "desc": "Scopri come impostare il primo progetto e i tuoi luoghi.",
    "cta": "Guarda il video"
  },
  "cta": "Vai alla dashboard",
  "receipt": "Una ricevuta e un'email di onboarding sono in arrivo a {{email}}.",
  "fallbacks": {
    "company": "la tua azienda",
    "plan": "il tuo piano",
    "inbox": "la tua casella di posta"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Il tuo account {{plan}} è attivo — gratis per sempre. Tre cose da fare ora."
}
